import axios from 'axios';
import qs from 'qs';

import { XTRAM_BOT_API_URL } from '../../env';

export default async function CallApi({
  method = 'GET',
  url = '',
  params = {},
  data = {},
  headers = {},
  baseURL,
  timeout = 120000,
}) {
  try {
    const apiClient = axios.create({
      baseURL: baseURL || XTRAM_BOT_API_URL,
      timeout,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
    });

    const response = await apiClient({ method, url, params, data, headers });
    return response.data;
  } catch (error) {
    const normalizedError = {
      message: error?.response?.data?.message || error.message || 'Unknown error',
      status: error?.response?.status || null,
      data: error?.response?.data || null,
      original: error,
    };

    // eslint-disable-next-line no-console
    console.error(`[XtramBot API ERROR] ${method} ${url}`, normalizedError);
    throw normalizedError;
  }
}

